import React from 'react'
import { navigate } from "gatsby"

import { Grid } from '@material-ui/core'
import newsStyle from "./newsStyle.jsx"
import withStyles from "@material-ui/core/styles/withStyles"

import articlesCat from '../../constants/ArticlesCategory'

const OtherArticleSection = ({ classes, article, baseUrl, articleNumber, idx, type }) => {

  const cat = type === 'article' && articlesCat.find((item) => article.category === item.code);

  const style = {
    cursor: type === 'article' ? 'pointer' : 'auto',
    pointerEvents: type === 'article' ? 'auto' : 'none',
  }

  return (
    <Grid container item direction='column' style={style} onClick={() => navigate(`${baseUrl}${article.title.replace(/[&\\#, +()$~%.'":*?<>{}]/g, '_')}`)}>
      <Grid item className={classes.articleDate}>
        {article.date}
      </Grid>
      <Grid item className={classes.titleOther}>
        {article.title}
      </Grid>
      {cat &&
        <Grid item className={classes.tabInfoOther}>
          <div dangerouslySetInnerHTML={{ __html: cat.label }} />
        </Grid>}
      {idx < articleNumber - 1 &&
        <Grid item className={classes.border100} />}
    </Grid>
  )
};

export default withStyles(newsStyle)(OtherArticleSection)
